import React, { useState, useContext, useEffect, useRef } from 'react';
import { Page, Carousel, Button, Alert } from 'components';
import useReactRouter from 'use-react-router';
import { Modal } from '@shopify/app-bridge-react';
import FirstStep from './settings/FirstStep';
import ShopContext from 'context/ShopContext';
import SecondStep from './settings/SecondStep';
import CampaignContext from 'context/CampaignContext';
import PreviewContext from 'context/PreviewContext';
import { useTransition, animated } from 'react-spring';
import _ from 'lodash';

const Create = () => {
	const { history } = useReactRouter();
	const [showConfirmCancel, setShowConfirmCancel] = useState(false);
	const [scrollTop, setScrollTop] = useState(0);
	const newCampaignContext = useContext(CampaignContext);
	const shopContext = useContext(ShopContext);
	const { validate, state, originalState, discard, validationErrors } = newCampaignContext;
	const { previewCampaign, setShowATUAfterText } = useContext(PreviewContext);
	const [activeTab, setActiveTab] = useState(0);
	const stickyHeader = useRef(null);
	const [stickyHeaderPosition, setStickyHeaderPosition] = useState(0);
	const transitions = useTransition(!_.isEqual(originalState, state), null, {
		from: { position: 'absolute', opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
	});

	// console.log("shopContext")
	// console.log(shopContext)
	useEffect(() => {
		previewCampaign(state);
	}, [state]);

	return (
		<Page
			padding={0}
			onScroll={(scrollTop) => {
				if (!stickyHeader.current) {
					setStickyHeaderPosition(0);
					return;
				}
				if (scrollTop > stickyHeader.current.offsetTop + 15)
					setStickyHeaderPosition(scrollTop - stickyHeader.current.offsetTop - 15);
				else setStickyHeaderPosition(0);
			}}
			header={{
				title: state.id ? state.name.substring(0, 25) : 'New Campaign',
			}}
			TopContent={{
				transitions,
				render: ({ error, loading }) => (
					<Alert
						type="save_settings"
						title="unsaved changes"
						borderPosition="none"
						paddingX="px-6"
						actions={[
							{
								text: 'Discard',
								type: 'secondary',
								loading: false,
								onClick: () => discard(),
							},
							{
								text: newCampaignContext.originalState.active ? 'Save' : 'Save & Activate',
								type: Object.values(validationErrors)
									.map((error) => error.filter(Boolean))
									.flat(Infinity)
									.filter(Boolean).length
									? 'danger'
									: 'primary',
								// disabled: Object.keys(validationErrors).length,
								onClick: () => {
									newCampaignContext.saveCampaign(
										!newCampaignContext.originalState.active ? { active: true } : {}
									);
								},
							},
						]}
					/>
				),
			}}
		>
			{/* <Carousel
				active={activeTab}
				contents={[
					<FirstStep context={newCampaignContext} setActiveTab={setActiveTab} />,
					<SecondStep
						setActiveTab={setActiveTab}
						context={newCampaignContext}
						stickyHeaderPosition={stickyHeaderPosition}
						stickyHeader={stickyHeader}
					/>,
				]}
			/> */}
			<FirstStep context={newCampaignContext} setActiveTab={setActiveTab} />
			<SecondStep
				setActiveTab={setActiveTab}
				context={newCampaignContext}
				shopContext={shopContext}
				stickyHeaderPosition={stickyHeaderPosition}
				stickyHeader={stickyHeader}
				setShowATUAfterText={setShowATUAfterText}
			/>
			<Modal
				title="Confirm Cancel"
				message="Are you sure, You want to cancel"
				open={showConfirmCancel}
				primaryAction={{
					content: 'Yes, Cancel',
					onAction: () => {
						setShowConfirmCancel(false);
						history.push('/campaigns');
					},
				}}
				secondaryActions={[
					{
						content: 'No',
						onAction: () => setShowConfirmCancel(false),
					},
				]}
			/>
		</Page>
	);
};

export default Create;
